import { memo, useEffect, useRef } from 'react';
import { isMobile } from 'react-device-detect';
import TrackingAPI from 'api/TrackingAPI';
import { analyticsService } from 'services/analyticsService';
import styled from 'styled-components';

import close_img from '../../assets/close.svg';
import Modal from "../../ui-kit/Modal";
import ImageModalSection from './components/ImageModalSection';
import MainContentModalSection from './components/MainContentModalSection';

const MobileCloseIcon = styled.img`
  position: fixed;
  right: 24px;
  top: 24px;
  width: 20px;
  height: 20px;
  z-index: 1000;
  cursor: pointer;
`;

interface IBuyTokensModalProps {
  isOpen: boolean;
  onClose: () => void;
  analyticsDataRenderReason?: string;
  analyticsData?: Record<string, unknown>;
}

const BuyTokensModal: React.FC<IBuyTokensModalProps> = (props) => {
  const { isOpen, onClose, analyticsDataRenderReason = '', analyticsData = {} } = props;

  const hasTrackedRef = useRef(false);

  useEffect(() => {
    const trackEvent = () => {
      if (hasTrackedRef.current) return;
      hasTrackedRef.current = true;
      try {
        TrackingAPI.trackEvent('buy_token_modal_open', {
          rendered_for_reason: analyticsDataRenderReason,
          ...analyticsData,
        });
        analyticsService.trackGoogleEvent('buy_token_modal_open', {
          ...analyticsData,
        });
      } catch (error) {
        throw error;
      }
    };

    trackEvent();
  }, [analyticsDataRenderReason, isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      canClose={true}
      className="stripe-offer-banner-modal"
      isVisibleCloseIcon={!isMobile}
    >
      {isMobile && <MobileCloseIcon onClick={onClose} src={close_img} alt="close" />}
      <Wrapper>
        {!isMobile && <ImageModalSection />}
        <MainContentModalSection onClose={onClose} />
      </Wrapper>
    </Modal>
  );
};

export default memo(BuyTokensModal);

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 65vw;
  min-height: 653px;
  max-height: 653px;
  max-width: 880px;
  min-width: 800px;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100vw;
    min-width: unset;
    max-height: unset;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    padding: 0;
  }

  @media (max-height: 700px) {
    height: 96vh;
    min-width: unset;
  }
`;
